import { defineComponent as _defineComponent } from 'vue';
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreRestrictionSpan',
    props: {
        isPrivate: Boolean,
    },
    setup(__props) {
        const props = __props;
        Vue.use(BootstrapVue);
        const text = computed(() => (props.isPrivate ? "private" : "unrestricted"));
        const title = computed(() => {
            if (props.isPrivate) {
                return "This dataset is stored on storage restricted to a single user. It can not be shared, published, or added to Galaxy data libraries.";
            }
            else {
                return "This dataset is stored on unrestricted storage. With sufficient Galaxy permissions, this dataset can be published, shared, or added to Galaxy data libraries.";
            }
        });
        return { __sfc: true, props, text, title };
    }
});
